import React, { useEffect } from "react";
import { connect } from "react-redux";
import BalanceDetails from "../../Component/WalletPage/BalanceDetails";
import Deposit from "../../Component/WalletPage/Deposit";
import Transaction from "../../Component/WalletPage/Transaction";
import Transfer from "../../Component/WalletPage/Transfer";
import WithdrawCrypto from "../../Component/WalletPage/WithdrawCrypto";
import { fetchWalletBalance, fetchWalletTransactions, fetchTransactions } from "../../Redux/Actions/dataActions";

function WalletPage({ fetchWalletBalance, fetchWalletTransactions, fetchTransactions, wallet, transactions }) {
    useEffect(() => {
        fetchWalletBalance();
        fetchWalletTransactions();
        fetchTransactions();
    }, [fetchWalletBalance, fetchWalletTransactions, fetchTransactions]);

    return (
        <div className="container-xxl">
            <div className="row g-3 mb-3 row-deck">
                <BalanceDetails walletData={wallet} />
                <WithdrawCrypto />
            </div>
            <div className="row g-3 mb-3 row-deck">
                <Deposit />
                <Transfer/>
            </div>
            <div className="row">
                <Transaction transactions={transactions} />
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    wallet: state.data?.wallet,
    transactions: state.data?.transactions,
});

export default connect(mapStateToProps, { 
    fetchWalletBalance, 
    fetchWalletTransactions, 
    fetchTransactions 
})(WalletPage);